import React, { useState } from 'react';
import DropDown from '../../../../components/ui/dropDown';
import { useCodeudor } from '../../hooks/useCodeudor';
import { SeguroCodeudorEdit } from '../../models/seguroCodeudorEdit';
import { SeguroRow } from './listaSeguros';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import { EliminarSeguro } from '../../models/seguroCodeudor';
import ActionMenu from '../../../../components/ui/materialui/actionMenu';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { useDetalleMutuoPermissions } from '../../hooks/useDetalleMutuoPermissions';
import { TipoFuncionalidad } from '../../../../utils/enums';
import { useDetalleMutuoAccess } from '../../../../components/auth/DetalleMutuoPermissionGuard';

interface IProps {
    seguroRow: SeguroRow;
    setSeguroCodeudorSeleccionado: (value: SeguroCodeudorEdit) => void;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
    renderizar: () => void;
    esVigente: boolean;
}

const seguroLabels: Record<SeguroRow["TipoSeguro"], string> = {
    CESANTIA: "cesantía",
    DESGRAVAMEN: "desgravamen"
};


const AccionesGrillaSegurosCodeudor: React.FC<IProps> = (props) => {
    const [show, setShow] = useState<boolean>(false);
    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    });
    const { obtenerSeguroCodeudor, eliminarSeguroCodeudor } = useCodeudor();
    const { hasAccess: puedeVer } = useDetalleMutuoAccess(
        props.esVigente,
        undefined,
        [TipoFuncionalidad.Bandeja_ver, TipoFuncionalidad.Cartera_ver]
    );
    // Validar si puede eliminar (Bandeja_editar)
    const { hasAccess: puedeEliminar } = useDetalleMutuoAccess(
        props.esVigente,
        TipoFuncionalidad.Bandeja_editar
    );

    async function handleEditSeguro() {

        const seguroCodeudorEdit: SeguroCodeudorEdit | void = await obtenerSeguroCodeudor(props.seguroRow.MutuoId,
            props.seguroRow.RutAsegurado!,
            props.seguroRow.TipoSeguro);

        if (!seguroCodeudorEdit) return;

        props.setSeguroCodeudorSeleccionado(seguroCodeudorEdit);
        props.setShowModal(true);

    }

    const handleDeleteSeguro = async () => {
        setModalConfirmacion({
            show: true,
            title: 'Eliminar seguro',
            message: `¿Estás seguro de eliminar el seguro ${seguroLabels[props.seguroRow.TipoSeguro]} con la póliza: ${props.seguroRow.CodigoPoliza}?`,
            metodo: () => {
                const data: EliminarSeguro = {
                    mutuoId: props.seguroRow.MutuoId,
                    rut: props.seguroRow.RutAsegurado ?? '',
                    tipoSeguro: props.seguroRow.TipoSeguro
                }
                eliminarSeguroCodeudor(data, props.renderizar);
            },
        });
    }

    const items = []
    if (puedeVer) {
        items.push({
            label: 'Ver seguro',
            icon: <SearchIcon />,
            onClick: handleEditSeguro,
        })
    }

    if (puedeEliminar) {
        items.push({
            label: 'Eliminar seguro',
            icon: <ClearIcon />,
            onClick: handleDeleteSeguro,
        })
    }
    return (
        <>
            <ActionMenu actions={items} />

            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({
                        ...modalConfirmacion,
                        show: false,
                    })
                }
                onConfirm={modalConfirmacion.metodo}
                show={modalConfirmacion.show}
                title={modalConfirmacion.title}
                message={modalConfirmacion.message}
            />
        </>
    );
};

export default AccionesGrillaSegurosCodeudor;
